import {Component} from '@angular/core';
import {AbstractProdForm, ProdFormField, ProdFormFieldType, ProdFormValidators, RequiredValidator,} from 'prod-form';
import {CompanyService} from "../../../../services/company.service";
import {CarService} from "../../../../services/car.service";
import {take} from "rxjs";
import {MatDialogRef} from "@angular/material/dialog";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-change-company-dialog',
  templateUrl: './change-company-dialog.component.html'
})
export class ChangeCompanyDialogComponent extends AbstractProdForm {
  title: string = this.translate.instant('cars.change_company_dialog.title');
  fields: ProdFormField[] = [
    ProdFormField.create({
      name: 'company',
      label: this.translate.instant('cars.change_company_dialog.company'),
      type: ProdFormFieldType.SELECT,
      selectParameters: {
        selectDataService: CompanyService,
        isMulti: false,
        isNarrowDown: true,
        isComplete: true
      },
      validators: new ProdFormValidators([
        new RequiredValidator()
      ])
    })
  ]

  constructor(
    public dialogRef: MatDialogRef<ChangeCompanyDialogComponent>,
    override dataService: CarService,
    private translate: TranslateService
  ) {
      super();
  }

  moveCars(event) {
    const payload = {
      cars: this.data['cars'],
      organization: event.formData.company
    }
    this.dataService.moveCars(payload)
      .pipe(take(1)).subscribe(res => {
      if (res['success']) {
        this.dialogRef.close();

      }
    })
  }
}
